/****************************************************************************************
 * File Name    : PatrolHistoryCreate.vue
 * Function     : 개정 이력 등록/수정 페이지
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  : 개정 이력 정보를 등록하거나 수정하는 페이지
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.04.16  	최명호    	Create
****************************************************************************************/
<template>
    <div>
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box">
                    <PageHeader :title="isEdit ? '개정 이력 수정하기' : '개정 이력 등록하기'" />
                </div>
            </a-col>
        </a-row>
        <a-form class="" :form="form" layout = "vertical" @submit="handleSubmit">
            <a-card>
                <a-form-item label="변경내용">
                    <a-textarea placeholder="변경 내용을 입력하세요" rows="5" v-decorator="['content',{initialValue: content, rules: [{ required: true, message: '변경내용을 입력하세요' }],},] "/>
                </a-form-item>
                <a-form-item label="참고사진">
                    <div v-if="imgSrc.length">
                        <span v-for="item in imgSrc" :key="item.seq" style="margin-right:20px; display: inline-block;">
                            <img :src="item.src" style="height: 80px; max-width: 150px; object-fit: contain;">
                            <span @click="deleteImg(item.seq);" style="cursor:pointer; vertical-align:bottom; margin-left: 5px;">
                                <a-icon type="delete" style="color: #ff4d4f;" />
                            </span>
                        </span>
                    </div>
                    <a-spin :spinning="spinning">
                        <a-upload name="file" :multiple="false" :action="$store.state.imageUploadServer" @change="imageUpload"
                            v-decorator="['photo',{rules: [{ required: false, message: '사진을 선택하세요' }],},]">
                            <a-button> <a-icon type="camera" /> 사진 선택 </a-button>
                        </a-upload>
                    </a-spin>
                </a-form-item>
                <a-form-item label="적용 일자">
                    <date-picker v-model="applyDate" valueType="format" placeholder="적용 일자를 선택하세요"></date-picker>
                </a-form-item>
            </a-card>
            <p/>
            <a-button type="primary" html-type="submit" :ghost="false" size="default" icon="save">저장</a-button>
            <a-divider type='vertical' />
            <a-button type="default" html-type="button" :ghost="false" size="default" icon="rollback" @click="goBack">취소</a-button>
        </a-form>
    </div>
</template>
<script>
import _ from "lodash";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import PageHeader from "../components/PageHeader.vue";
export default {
    name: 'PatrolHistoryCreate',
    components: {
        PageHeader ,
        DatePicker, 
    },
    data() {
        return {
            isEdit: false,
            seq: null,
            productCsSeq: null,
            fileUploadSeq: '',
            spinning: false,
            content: '',
            applyDate: '',
            imgSrc: [],
            fileDelimiter: '||'
        };
    },
    beforeCreate() {
        this.form = this.$form.createForm(this, { name: 'validate_other' });
    },
    mounted() {
        // 수정 모드인지 확인
        if (this.$route.query.seq) {
            this.isEdit = true;
            this.seq = this.$route.query.seq;
            // 수정 모드에서도 productCsSeq를 쿼리에서 가져옴 (URL에서 전달된 경우)
            if (this.$route.query.productCsSeq) {
                this.productCsSeq = this.$route.query.productCsSeq;
            }
            this.loadHistoryItem();
        } else {
            // 새 항목 등록 모드
            this.productCsSeq = this.$route.query.productCsSeq;
        }
    },
    methods: {
        // 데이터 로드 (수정 모드인 경우)
        loadHistoryItem() {
            this.spinning = true;
            const url = `${this.$store.state.nodeApiUrl}/product/patrol_history_item/${this.seq}`;
            
            this.$http.get(url)
                .then((response) => {
                    if (response.status === 200 && response.data) {
                        const item = response.data;
                        
                        // 폼 데이터 설정
                        this.form.setFieldsValue({
                            content: item.CONTENT
                        });
                        
                        // GMT 날짜를 한국 시간으로 변환
                        if (item.APPLY_DATE) {
                            const date = new Date(item.APPLY_DATE);
                            const koreanDate = new Date(date.getTime() + (9 * 60 * 60 * 1000));
                            this.applyDate = this.formatDateToYYYYMMDD(koreanDate);
                        }
                        
                        // Product CS SEQ 설정 (이 부분이 누락되어 있었음)
                        this.productCsSeq = item.PRODUCT_CS_SEQ;
                        
                        // 이미지 목록 설정
                        this.fileUploadSeq = item.UPLOAD_FILE_SEQ_LIST || '';
                        
                        // 이미지 로드
                        this.loadImages();
                    }
                    this.spinning = false;
                })
                .catch((error) => {
                    console.error('이력 상세 조회 실패:', error);
                    this.$message.error('이력 정보를 불러오는 중 오류가 발생했습니다.');
                    this.spinning = false;
                });
        },
        
        // 이미지 목록 로드
        loadImages() {
            const files = this.fileUploadSeq.split(this.fileDelimiter);
            this.imgSrc = [];
            
            _.forEach(files, (seq) => {
                if (seq) {
                    this.imgSrc.push({
                        seq: seq,
                        src: this.$store.state.hostInService + '/upload/image/download/' + seq
                    });
                }
            });
        },
        
        // 이미지 삭제
        deleteImg(seq) {
            if (confirm('선택한 이미지를 삭제하시겠습니까?')) {
                let files = this.fileUploadSeq.split(this.fileDelimiter);
                files = _.reject(files, (item) => {
                    return item == seq;
                });
                this.fileUploadSeq = files.join(this.fileDelimiter);
                
                // 이미지 목록 다시 로드
                this.loadImages();
            }
        },
        
        // 이미지 업로드
        imageUpload(info) {
            this.spinning = info.file.status === 'uploading';
            
            if (info.file.status === 'done') {
                let files = this.fileUploadSeq.split(this.fileDelimiter);
                files = _.filter(files, (seq) => {
                    return seq;
                });
                
                this.$message.success(`${info.file.name} 파일이 성공적으로 업로드되었습니다.`);
                files.push(info.file.response.data.uploadFileSeq);
                this.fileUploadSeq = files.join(this.fileDelimiter);
                
                // 이미지 목록 다시 로드
                this.loadImages();
                
                // 이미지 리사이징 API 호출
                this.$http.post(`${this.$store.state.nodeApiUrl}/user/resize-image`, {
                    uploadFileSeq: info.file.response.data.uploadFileSeq
                })
                .then(response => {
                    if (response.data.code === 'success') {
                        console.log('✅ Image resized:', response.data.data);
                    }
                })
                .catch(error => {
                    console.error('❌ Resize failed:', error);
                });
            } else if (info.file.status === 'error') {
                this.$message.error(`${info.file.name} 파일 업로드에 실패했습니다.`);
            }
        },
        
        // 폼 제출 (저장)
        handleSubmit(e) {
            e.preventDefault();
            
            this.form.validateFields((err, values) => {
                if (!err) {
                    if (!this.applyDate) {
                        this.$message.warning('적용 일자를 선택해주세요.');
                        return;
                    }
                    
                    this.spinning = true;
                    
                    // 저장할 데이터 구성
                    const formData = {
                        product_cs_seq: this.productCsSeq,
                        content: values.content,
                        apply_date: this.applyDate,
                        upload_file_seq_list: this.fileUploadSeq
                    };
                    
                    let url, method;
                    
                    if (this.isEdit) {
                        // 수정 모드
                        url = `${this.$store.state.nodeApiUrl}/product/patrol_history_update/${this.seq}`;
                        method = 'put';
                    } else {
                        // 등록 모드
                        url = this.$store.state.nodeApiUrl + '/product/patrol_history_create';
                        method = 'post';
                    }
                    
                    this.$http[method](url, formData)
                        .then((response) => {
                            if (response.status === 200) {
                                this.$message.success(this.isEdit ? '수정되었습니다.' : '등록되었습니다.');
                                this.goBack();
                            }
                            this.spinning = false;
                        })
                        .catch((error) => {
                            console.error(this.isEdit ? '수정 중 오류 발생:' : '등록 중 오류 발생:', error);
                            this.$message.error(this.isEdit ? '수정 중 오류가 발생했습니다.' : '등록 중 오류가 발생했습니다.');
                            this.spinning = false;
                        });
                }
            });
        },
        
        // 취소 (뒤로 가기)
        goBack() {
            this.$router.push({ path: `/patrolHistoryList/${this.productCsSeq}` });
        },
        
        // YYYY-MM-DD 형식으로 날짜 포맷팅
        formatDateToYYYYMMDD(date) {
            const year = date.getUTCFullYear();
            const month = String(date.getUTCMonth() + 1).padStart(2, '0');
            const day = String(date.getUTCDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
    }
}
</script>
<style scoped>
</style> 